import React from 'react';
import help from '../../assets/images/icons/help.png';
import {NavLink, Link} from "react-router-dom";
import {Helmet} from "react-helmet";
import metatags from '../static/metatags';

class Plan extends React.Component {
  constructor(props){
    super(props);
    this.step2 = React.createRef();
    this.step3 = React.createRef();
    this.step4 = React.createRef();
    this.step1_Content = React.createRef();
    this.state = {
      monThu: true,
      allday: false,
      visits: 1,
      // guests: 1,
      guests: 0,
      period: 'monthly',
      type: 'location',
      p_step1:true,
      p_step2:false,
      p_step3:false,
      p_step4:false,
      continueBtnDisable: false,
      fPriceSH: false,
    }
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
  };
  
  
  plan_onChangeFun = (e, getFold, getStep) => {
    if(getStep == 'allTheatres'){
      // this.props.GetAllTheatresJson();
      this.setState({
        type:'allTheatre',
        fPriceSH: true,
      }, () => {
        this.props.getPlanJsonPlanPage(this.state);
      })
    }else if(getStep == 'changeRegion'){
      this.setState({
        type:'region',
        fPriceSH: true,
      }, () => {
        this.props.getPlanJsonPlanPage(this.state);
      })
    }else if(getStep == 'changeLocations'){
      this.setState({
        type:'location',
        fPriceSH: true,
      }, () => {
        this.props.getPlanJsonPlanPage(this.state);
      })
    }else if(getStep == 'monThu'){
      this.setState({
        monThu: true,
        allday: false,
      })
    }else if(getStep == 'allday'){
      this.setState({
        monThu: false,
        allday: true,
      })
    }else if(getStep == 'visit-1'){
      this.setState({visits: 1})
    }else if(getStep == 'visit-2'){
      this.setState({visits: 2})
    }else if(getStep == 'visit-3'){
      this.setState({visits: 3})
    }else if(getStep == 'visit-4'){
      this.setState({visits: 4})
    }else if(getStep == 'visit-5'){
      this.setState({visits: 5})
    }else if(getStep == 'visit-6'){
      this.setState({visits: 6})
    }else if(getStep == 'myselfonly'){
      this.setState({
        guests: 0,
        continueBtnDisable: true
      })
    }else if(getStep == 'guest-1'){
      this.setState({
        guests: 1,
        continueBtnDisable: true
      })
    }else if(getStep == 'guest-2'){
      this.setState({
        guests: 2,
        continueBtnDisable: true
      })
    }else if(getStep == 'guest-3'){
      this.setState({
        guests: 3,
        continueBtnDisable: true
      })
    }else if(getStep == 'guest-4'){
      this.setState({
        guests: 4,
        continueBtnDisable: true
      })
    }else if(getStep == 'guest-5'){
      this.setState({
        guests: 5,
        continueBtnDisable: true
      })
    }


    if(getFold == 'step1'){
      setTimeout(() => {
        window.scrollTo(0, this.step2.current.offsetTop - 90);
      }, 200);
      this.setState({p_step2:true})
    }else if(getFold == 'step2'){
      setTimeout(() => {
        window.scrollTo(0, this.step3.current.offsetTop - 90);
      }, 200);
      this.setState({p_step3:true})
    }else if(getFold == 'step3'){
      setTimeout(() => {
        window.scrollTo(0, this.step4.current.offsetTop - 90);
      }, 200);
      this.setState({p_step4:true})
    }
  }

  plan_continueBtn = () => {
    var getState = this.state;
    this.props.plan_continueCalling(getState);
    console.log(this.step1_Content.current?.innerText);
    

    // create API > payload
    this.props.createAPI_additionalInfo(getState);
    
  }

  cBtnDisabled = () => {
    var disabled = false;
    if(this.state.continueBtnDisable == true){
      disabled = true;
    }else{
      disabled = false;
    }
    return disabled;
  }

  render() {
    return (
      <section className="cmx-plan-page">
        <Helmet>
          <title>{metatags.commonMetatag.title}</title>
          <meta name="description" content={metatags.commonMetatag.description} />
        </Helmet>
        <section className="row">
            <section className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <aside className='head text-center pt-4 pb-4'>
                <h1><span className='txt-top d-block'>Customize Your Plan</span><span className='txt-btm d-block pt-1'>Build Your Own Plan by Answering Four Questions</span></h1>
              </aside>
              <section className='plan-blk'>
                {this.state.p_step1 &&
                  <section className='box'>
                    <aside className='head-wrap'>
                      <p><span className='num d-inline-block align-middle'>1</span> <span className='des d-inline-block align-middle'>Where do you want to use your CMX Passport?</span></p>
                    </aside>
                    <aside className='body-wrap'>
                      <ul>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-1" id="plan-3" onChange={(e) => this.plan_onChangeFun(e, 'step1', 'changeLocations')} />
                            <label htmlFor="plan-3" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p className='d-inline-block' ref={this.step1_Content}><i id="location">{this.props.state.loc_name}</i> &nbsp;
                                    <a onClick={this.props.Plan_changeLocationModel} className='text-decoration-underline d-inline-block' href='javascript:;' title='Change location'>Change location</a>
                                  </p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, this.state.guests, this.state.period, 'location')}</p>
                                </aside>
                                {/* <aside className='regin text-end pt-2'>
                                  <a onClick={this.props.Plan_changeLocationModel} className='text-decoration-underline d-inline-block' href='javascript:;' title='Change location'>Change location</a>
                                </aside> */}
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-1" id="plan-2" onChange={(e) => this.plan_onChangeFun(e, 'step1', 'changeRegion')} />
                            <label htmlFor="plan-2" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p ref={this.step1_Content}><i id="changeRegion">{this.props.state.allLoc_Name}</i> &nbsp;
                                  <a href="javascript:;" onClick={this.props.plan_regionSeeThtreList} className='d-inline-block align-bottom text-decoration-underline' title='VView Included Theatres'>View Included Theatres</a></p>
                                  {/* <p>
                                    {
                                      this.props.state.region_firstObj.length > 0 &&
                                      <span className='d-inline-block align-top'>
                                        {this.props.state.region_firstObj[0].Theater[0]}, {this.props.state.region_firstObj[0].Theater[1]} &amp; More &nbsp;
                                      </span> 
                                    }
                                    <a href="javascript:;" onClick={this.props.plan_regionSeeThtreList} className='d-inline-block align-bottom text-decoration-underline' title='View Theatre List'>View Theatre List</a>
                                  </p> */}
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, this.state.guests, this.state.period, 'region')}</p>
                                </aside>
                                {/* <aside className='regin text-end pt-2'>
                                  <span onClick={this.props.Plan_changeRegion} className='text-decoration-underline d-inline-block' title='Change region'>Change region</span>
                                </aside> */}
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-1" id="plan-1" onChange={(e) => this.plan_onChangeFun(e, 'step1', 'allTheatres')}/>
                            <label htmlFor="plan-1" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p ref={this.step1_Content}><i id="allTheatres">All CMX Theatres in the U.S.</i></p>
                                  <p>
                                    <span className='d-inline-block align-top'>Includes all CMX Concepts</span>&nbsp;
                                    <a href="javascript:;" onClick={this.props.plan_allTheatre_SeeThtreList} className='d-inline-block align-bottom text-decoration-underline' title='View Included Theatres'>View Included Theatres</a>
                                  </p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, this.state.guests, this.state.period, 'allTheatre')}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                      </ul>
                    </aside>
                  </section>
                }
                
                {this.state.p_step2 &&
                  <section className='box step2-box' ref={this.step2}>
                    <aside className='head-wrap'>
                      <p><span className='num d-inline-block align-middle'>2</span> <span className='des d-inline-block align-middle'>Pick which days to watch movies with your CMX Passport</span></p>
                    </aside>
                    <aside className='body-wrap'>
                      <ul>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-2" id="plan-4" onChange={(e) => this.plan_onChangeFun(e, 'step2', 'monThu')} />
                            <label htmlFor="plan-4" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p><i id="monThu">Monday - Thursday</i> <i id="subMonThu">(Thursday only before 6pm)</i></p>
                                  {/* <p>
                                    <span className='d-inline-block align-top'>Excludes Holidays</span>
                                    <a href='javascript:;' className='tooltip-blk d-inline-block align-middle position-relative'>
                                      <figure className='d-inline-block align-middle pt-2 ps-1'><img src={help} alt="Help" className="img-fluid" /></figure>
                                      <aside className='tool'>
                                        <p>New Year's Day, Valentines Day, Martin Luther King Jr. Day, Memorial Day, Independence Day, Labor Day, Thanksgiving Day, Christmas Day.</p>
                                      </aside>
                                    </a>
                                  </p> */}
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(true, false, this.state.visits, this.state.guests, this.state.period, this.state.type)}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-2" id="plan-5" onChange={(e) => this.plan_onChangeFun(e, 'step2', 'allday')} />
                            <label htmlFor="plan-5" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p><i id="allday">Any day of the year</i></p>
                                  <p><span className='d-inline-block align-top' id="subAllday">No restrictions</span></p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(false, true, this.state.visits, this.state.guests, this.state.period, this.state.type)}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                      </ul>
                    </aside>
                  </section>
                }
                
                {this.state.p_step3 &&
                  <section className='box visit-blk' ref={this.step3}>
                    <aside className='head-wrap'>
                    <p><span className='num d-inline-block align-middle'>3</span> <span className='des d-inline-block align-middle'>Pick how many movies per month for yourself <small>Unused credits will rollover up to 1 year. You’ll choose guest credits in the next step.</small></span></p>
                    </aside>
                    <aside className='body-wrap'>
                      <ul>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="visitPlan-3" id="visit-1" onChange={(e) => this.plan_onChangeFun(e, 'step3', 'visit-1')} />
                            <label htmlFor="visit-1" className='d-inline-block'>
                              <aside className='content'>
                                  <p><span className='txt'>Once</span><span className='price'>${this.props.getPrice(this.state.monThu, this.state.allday, 1, this.state.guests, this.state.period, this.state.type)}</span></p>
                              </aside>
                              <span className="radio-btn" id="visit1">1</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="visitPlan-3" id="visit-2" onChange={(e) => this.plan_onChangeFun(e, 'step3', 'visit-2')} />
                            <label htmlFor="visit-2" className='d-inline-block'>
                              <aside className='content'>
                                  <p><span className='txt'>Twice</span><span className='price'>${this.props.getPrice(this.state.monThu, this.state.allday, 2, this.state.guests, this.state.period, this.state.type)}</span></p>
                              </aside>
                              <span className="radio-btn" id="visit2">2</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="visitPlan-3" id="visit-3" onChange={(e) => this.plan_onChangeFun(e, 'step3', 'visit-3')} />
                            <label htmlFor="visit-3" className='d-inline-block'>
                              <aside className='content'>
                                  <p><span className='txt'>Thrice</span><span className='price'>${this.props.getPrice(this.state.monThu, this.state.allday, 3, this.state.guests, this.state.period, this.state.type)}</span></p>
                              </aside>
                              <span className="radio-btn" id="visit3">3</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="visitPlan-3" id="visit-4" onChange={(e) => this.plan_onChangeFun(e, 'step3', 'visit-4')} />
                            <label htmlFor="visit-4" className='d-inline-block'>
                              <aside className='content'>
                                  <p><span className='txt'>Four Times</span><span className='price'>${this.props.getPrice(this.state.monThu, this.state.allday, 4, this.state.guests, this.state.period, this.state.type)}</span></p>
                              </aside>
                              <span className="radio-btn" id="visit4">4</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="visitPlan-3" id="visit-5" onChange={(e) => this.plan_onChangeFun(e, 'step3', 'visit-5')} />
                            <label htmlFor="visit-5" className='d-inline-block'>
                              <aside className='content'>
                                  <p><span className='txt'>Five Times</span><span className='price'>${this.props.getPrice(this.state.monThu, this.state.allday, 5, this.state.guests, this.state.period, this.state.type)}</span></p>
                              </aside>
                              <span className="radio-btn" id="visit5">5</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="visitPlan-3" id="visit-6" onChange={(e) => this.plan_onChangeFun(e, 'step3', 'visit-6')} />
                            <label htmlFor="visit-6" className='d-inline-block'>
                              <aside className='content'>
                                  <p><span className='txt'>Six Times</span><span className='price'>${this.props.getPrice(this.state.monThu, this.state.allday, 6, this.state.guests, this.state.period, this.state.type)}</span></p>
                              </aside>
                              <span className="radio-btn" id="visit6">6</span>
                            </label>
                          </aside>
                        </li>
                      </ul>
                      {/* <aside className='visit-btm'>
                        <p>Unused tickets will rollover to the next month.</p>
                      </aside> */}
                    </aside>
                  </section>
                }

                {this.state.p_step4 &&
                  <section className='box remove-border' ref={this.step4}>
                    <aside className='head-wrap'>
                      <p><span className='num d-inline-block align-middle'>4</span> <span className='des d-inline-block align-middle'>Choose how many guests you’ll bring with you to each movie <small>Unused Guest credits will rollover up to 1 year. Any quantity of Guest credits available in your account can be used for any movie.</small></span></p>
                    </aside>
                    <aside className='body-wrap'>
                      <ul className='remove-br'>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-3" id="plan-6" onChange={(e) => this.plan_onChangeFun(e, 'step4', 'myselfonly')} />
                            <label htmlFor="plan-6" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p id="guest0">Myself only</p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, 0, this.state.period, this.state.type)}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-3" id="plan-7" onChange={(e) => this.plan_onChangeFun(e, 'step4', 'guest-1')} />
                            <label htmlFor="plan-7" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p id="guest1">Myself + 1 Guest</p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, 1, this.state.period, this.state.type)}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-3" id="plan-8" onChange={(e) => this.plan_onChangeFun(e, 'step4', 'guest-2')} />
                            <label htmlFor="plan-8" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p id="guest2">Myself + 2 Guests</p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, 2, this.state.period, this.state.type)}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-3" id="plan-9" onChange={(e) => this.plan_onChangeFun(e, 'step4', 'guest-3')} />
                            <label htmlFor="plan-9" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p id="guest3">Myself + 3 Guests</p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, 3, this.state.period, this.state.type)}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-3" id="plan-10" onChange={(e) => this.plan_onChangeFun(e, 'step4', 'guest-4')} />
                            <label htmlFor="plan-10" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p id="guest4">Myself + 4 Guests</p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, 4, this.state.period, this.state.type)}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                        <li>
                          <aside className='form-group'>
                            <input type="radio" name="planradio-3" id="plan-11" onChange={(e) => this.plan_onChangeFun(e, 'step4', 'guest-5')} />
                            <label htmlFor="plan-11" className='d-block'>
                              <aside className='content'>
                                <aside className='lft text-start'>
                                  <p id="guest5">Myself + 5 Guests</p>
                                </aside>
                                <aside className='rgt text-end'>
                                  <p>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, 5, this.state.period, this.state.type)}</p>
                                </aside>
                              </aside>
                              <span className="radio-btn">&nbsp;</span>
                            </label>
                          </aside>
                        </li>
                      </ul>
                      {/* <ul className='last-para-br'>
                        <li>
                          <aside className='form-group last-para'>
                            <label><p>Unused Guest tickets will rollover up to 1 year. Any quantity of Guest tickets available in your account can be used for any movie.</p></label>
                          </aside>
                        </li>
                      </ul> */}
                    </aside>
                  </section>
                }
              </section>
            </section>

            {/* Footer > start */}
            {
              this.state.fPriceSH &&
                <section className='footer-price-blk'>
                  <section className='content'>
                    <section className='lft text-start'>
                      {
                        this.state.fPriceSH &&
                        <p className='mob-price'>Price 
                          <span>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, this.state.guests, this.state.period, this.state.type)}<i>/mo</i></span>
                        </p>
                      }
                      {
                        this.state.fPriceSH &&
                        <p className='desktop'>Price of your selection:&nbsp;
                          <span>${this.props.getPrice(this.state.monThu, this.state.allday, this.state.visits, this.state.guests, this.state.period, this.state.type)}<i>/mo</i></span>
                        </p>
                      }
                    </section>
                    <section className='rgt'>
                      <aside className="cmx-flex-btn-group text-end">
                        {/* <a className="flex-btn" href="javascript:;" title="CONTINUE"><span>continue</span></a> */}
                        <Link onClick={this.plan_continueBtn} className={`flex-btn ${this.cBtnDisabled() ? '':'disabled'}`} exact to={"/billing"} title='CONTINUE'><span>continue</span></Link>
                      </aside>
                    </section>
                  </section>
                </section>
            }
            {/* Footer > end */}

          </section>
      </section>
    )
  }
}

export default Plan;
